<script setup lang="ts">
const route = useRoute('page-term');
const { t } = useTexts();
const { closeModal } = useLayoutStore();
const { getCurrentLangTermsPlusDefaultTerms } = useTermsStore();
const { termsLinks } = storeToRefs(useTermsStore());

const termSeo = ref<string>('');
const isLoading = ref<boolean>(true);

const termsLinksRoutes = computed(() => {
  return termsLinks.value.map((item) => item.route);
});

const hasTermLink = computed(() => {
  const localeMatch = route.path.match(/^\/(\w{2,5})\/page\/(.+)/);

  if (!localeMatch) {
    return termsLinksRoutes.value.includes(route.path);
  } else {
    const page = localeMatch[2];

    return termsLinksRoutes.value.includes(`/page/${page}`);
  }
});

useSeo({
  title: t(termSeo.value),
});

onBeforeMount(async () => {
  if (!termsLinks.value.length) {
    await getCurrentLangTermsPlusDefaultTerms('pt-br');

    isLoading.value = false;
  }

  if (termsLinksRoutes.value.includes(route.path)) {
    const link = termsLinks.value.find((item) => item.route === route.path);

    termSeo.value = link?.title || '';
  } else termSeo.value = t('error.page_not_found.subtitle');
});

onMounted(() => {
  closeModal();
});
</script>

<template>
  <PagesTerms
    v-if="hasTermLink"
    :route-name="route.params.term"
  />
  <div
    v-else-if="isLoading"
    class="skeleton-loading h-96 mb-12 w-full"
  />
  <div v-else>
    <BaseErrorMessage
      image-type="error"
      :language-switcher="true"
      :message="$t('error.page_not_found.message')"
      :subtitle="$t('error.page_not_found.subtitle')"
      title="404"
    >
      <NuxtLink
        class="btn-primary"
        :to="localeLink('/')"
      >
        {{ $t('error.page_not_found.button') }}
      </NuxtLink>
    </BaseErrorMessage>
  </div>
</template>

<style module lang="scss">
// stylr
</style>
